import React from 'react';
import { PreparePage } from '@/layouts';
import { RoleType } from '@/constants';
import { CollapsePanel, Error, SkeletonFramework } from '../components';
import { Menu } from './Menu';
import { Content } from './Content';
import { useCourse } from './index.ViewHook';
import { ContentsType } from '@/api/seller/serv/oec_seller_learning_center_api';

export const Course = ({ handleError }) => {
  const { wait, handleChange } = useCourse();

  return (
    <PreparePage
      wait={wait}
      loadingNode={<SkeletonFramework className="mt-40" block={3} />}
      handleError={handleError}>
      <section className="flex">
        <CollapsePanel
          tab={ContentsType.Courses}
          onChange={handleChange}
          forSeller={{
            menu: <Menu type={RoleType.Seller} />,
            content: <Content type={RoleType.Seller} />,
          }}
          forCreator={{
            menu: <Menu type={RoleType.Creator} />,
            content: <Content type={RoleType.Creator} />,
          }}
        />
      </section>
    </PreparePage>
  );
};
